import { Box, Container, Grid, Typography } from "@mui/material";
import { BreadCrumb, RenderHTML } from "components";
import { useBreadCrumbs } from "hooks";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MyLearning_Link_Paths, HEADER_CLICK_TYPES } from "utils/constants";
import portalSettingsManager from "utils/portalSettingsManager";
import { ELEMENT_ID } from "utils/constants";
import { useStyles } from "./learningRequest-Styles";

export const LearningRequest = (): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleBreadCrumb, handleBreadCrumbNavigation, breadCrumbData } = useBreadCrumbs();
  const handleBreadCrumbClick = (path: string, breadCrumbKey: any) => {
    handleBreadCrumbNavigation(path, breadCrumbKey);
  };
  useEffect(() => {
          handleBreadCrumb([
              { title: t('home'), path: "/" },
              { title: t("learning_request"), path: MyLearning_Link_Paths.LearningRequest, type: HEADER_CLICK_TYPES.LEARNING_REQUEST },
          ], "override", "");
      }, []);

  return (
    <Container>
        <Box className={classes.container} id={ELEMENT_ID.BREADCRUMB}>
            <BreadCrumb
            breadCrumbData={breadCrumbData}
            handleBreadCrumbClick={handleBreadCrumbClick}
            separator="›"
            hideArrow={true}
            breadCrumbClass={classes.breadCrumbClass}
            ></BreadCrumb>
        </Box>
        <Grid container className={classes.subheader}>
            <Grid size={{ md: 9, sm: 8, xs: 12 }}>
                <Typography
                    className={classes.subheaderTitle}
                    variant="h1"
                    id={`${HEADER_CLICK_TYPES.LEARNING_REQUEST}-${ELEMENT_ID.NAME}`}
                >
                    {t("learning_request")}
                </Typography>
                <Box mt={2}>
                    <Typography variant="body1" component="div" style={{ whiteSpace: "pre-line" }}>
                        <RenderHTML
                            content={t("newLearningRequest", {
                                clientGuidance: portalSettingsManager?.application?.common?.newLearningRequest_ClientGuidance,
                            })}
                        />
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    </Container>
  );
};